/*****************
 * 该文件提供一些和日期处理有关的常用方法
 ****************/


/**
 * 获取两个日期之间的天数差
 */
function diffDate(date1, date2) {
  checkParameter(date1, Date);
  checkParameter(date2, Date);

  // 获取规范化后的日期对应的时间
  const formalizeTime = (date) => {
    return formalizeDate(date).getTime();
  }
  return Math.floor((formalizeTime(date1) - formalizeTime(date2)) / 1000 / 3600 / 24);
}

/**
 * 返回两个日期中间的所有日期，包含开头和结尾
 * @param {Date} earlyDate 最早日期
 * @param {Date} lateDate 最晚日期
 */
function datesInRange(earlyDate, lateDate = earlyDate) {
  const result = [];
  const diff = diffDate(lateDate, earlyDate);
  if (diff < 0) {
    return null;
  }
  let current = new Date(earlyDate);
  for (let i = 0; i <= diff; i++) {
    result.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return result;
}

/**
 * 规范化日期
 * 返回 时、分、秒 被设置为 0，而 年、月、日 相同的日期
 * @param {Date} date 需要被正规化的日期
 * @returns {Date}
 */
function formalizeDate(date) {
  checkParameter(date, Date);

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * 断言 value instanceof type
 * @param {*} value 待检查的参数
 * @param {Function} type 类型
 */
function checkParameter(value, type) {
  if (!(toObj(value) instanceof type)) {
    throw new Error(value + ' is not instanceof ' + type)
  }
  return value;
}

function tomorrow(date) {
  let copy = new Date(date);
  copy.setDate(copy.getDate() + 1);
  return copy;
}

function newDate(date, offset) {
  let d = new Date(date);
  d.setDate(date.getDate() + offset);
  return d;
}

function toObj(value) {
  switch (typeof value) {
    case 'boolean':
      return new Boolean(value);
    case 'number':
      return new Number(value);
    case 'string':
      return new String(value);
    default:
      return value;
  }
}

function fillZero(number, digits = 2) {
  number = String(number);
  var length = number.length;
  if (number.length < digits) {
    for (var i = 0; i < digits - length; i++) {
      number = "0" + number;
    }
  }
  return number;
}

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return year + "-" + fillZero(month + 1) + "-" + fillZero(d);
}

function str2date(str) {
  if (typeof str === 'string') {
    let [year, month, date] = str.split("-");
    month -= 1; // 输入月份是 1-12 而 Date 月份是 0-11，这里做转化。
    let result = new Date(year, month, date);
    return result;
  } else if (str instanceof Date) {
    return str;
  }
}

/**
 * 将 08:00 的时间转换到 480
 */
function timeStr2num(str) {
  const [h, m] = str.split(":");
  return (parseInt(h) || 0) * 60 + (parseInt(m) || 0);
}

/**
 * 将 840 转换到 14:00
 */
function num2timeStr(num) {
  const h = Math.floor(num / 60) % 24;
  const m = num % 60;
  return `${fillZero(h)}:${fillZero(m)}`;
}

/**
 * 从 date 中读取时间 返回 hh:mm
 * 如输入 new Date()
 * 返回 08:00
 * @param {Date} date 待转换时间
 */
function date2timeStr(date) {
  const h = date.getHours();
  const m = date.getMinutes();
  return `${fillZero(h)}:${fillZero(m)}`;
}

export {
  diffDate,
  checkParameter,
  formalizeDate,
  tomorrow,
  datesInRange,
  newDate,
  fillZero,
  date2str,
  str2date,
  timeStr2num,
  num2timeStr,
  date2timeStr,
}